import { render } from "./SelectVisits.vue?vue&type=template&id=f94170ce"
import script from "./SelectVisits.vue?vue&type=script&lang=js"
export * from "./SelectVisits.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/punchline-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__